import { OwlDateTimeIntl } from 'ng-pick-datetime';
import { Injectable } from '@angular/core';

@Injectable()
export class DefaultDatePickerIntl extends OwlDateTimeIntl {
  upSecondLabel = 'Adicionar um segundo';

  downSecondLabel = 'Diminuir um segundo';

  upMinuteLabel = 'Adicionar um minuto';

  downMinuteLabel = 'Diminuir um minuto';

  upHourLabel = 'Adicionar uma hora';

  downHourLabel = 'Diminuir uma hora';

  prevMonthLabel = 'Mês anterior';

  nextMonthLabel = 'Próximo mês';

  prevYearLabel = 'Ano anterior';

  nextYearLabel = 'Próximo ano';

  switchToMonthViewLabel = 'Mudar para a visão mensal';

  switchToMultiYearViewLabel = 'Escolha um mês e ano';

  cancelBtnLabel = 'Cancelar';

  setBtnLabel = 'Confirmar';

  rangeFromLabel = 'De';

  rangeToLabel = 'Até';

  hour12AMLabel = 'AM';

  hour12PMLabel = 'PM';
}
